export interface IPortfolioNewsListKeyParams {
  page: number
  pageSize: number
  search: string
  company: string
}

export const portfolioNewsKeys = {
  all: ['portfolio-news'] as const,
  list: (params: IPortfolioNewsListKeyParams) =>
    [...portfolioNewsKeys.all, 'list', params] as const,
  companies: () => [...portfolioNewsKeys.all, 'companies'] as const,
  detail: (articleId: string) =>
    [...portfolioNewsKeys.all, 'detail', articleId] as const,
} as const

export interface IDocumentsListKeyParams {
  page: number
  pageSize: number
}

export const documentsKeys = {
  all: ['documents'] as const,
  list: (params: IDocumentsListKeyParams) =>
    [...documentsKeys.all, 'list', params] as const,
} as const

export interface IFundUpdatesListKeyParams {
  page: number
  pageSize: number
  category: string
}

export const fundUpdatesKeys = {
  all: ['fund-updates'] as const,
  list: (params: IFundUpdatesListKeyParams) =>
    [...fundUpdatesKeys.all, 'list', params] as const,
  stats: () => [...fundUpdatesKeys.all, 'stats'] as const,
  categories: () => [...fundUpdatesKeys.all, 'categories'] as const,
  download: (fileId: string) =>
    [...fundUpdatesKeys.all, 'download', fileId] as const,
} as const

export const whyWeInvestKeys = {
  all: ['why-we-invest'] as const,
  list: () => [...whyWeInvestKeys.all, 'list'] as const,
} as const
